define('presentation/welcome/validators/onboardingDeliveryValidator',[
        'common/converters/phoneNumberFormatter',
        'common/promises/promiseFactory',
        'common/specifications/validEmailAddressSpecification',
        'constants/countryEnumerations',
        'presentation/common/validation/commonValidator',
        'presentation/common/validation/validationRule',
        'presentation/common/validation/validPhoneNumberSpecification'
    ],
    function() {
        return function() {
            let self = this;

            let _facade = null;
            let _viewModel = null;
            let _commonValidator = null;

            const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
            const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

            const PhoneNumberFormatter = require('common/converters/phoneNumberFormatter');
            const _phoneNumberFormatter = new PhoneNumberFormatter();

            const PromiseFactoryConstructor = require('common/promises/promiseFactory');
            const _promiseFactory = new PromiseFactoryConstructor();

            const ValidEmailAddressSpecificationConstructor = require('common/specifications/validEmailAddressSpecification');
            const _validEmailAddressSpecification = new ValidEmailAddressSpecificationConstructor();

            const ValidPhoneNumberSpecificationConstructor = require('presentation/common/validation/validPhoneNumberSpecification');
            const _validPhoneNumberSpecification = new ValidPhoneNumberSpecificationConstructor();

            const _countryEnumerations = require('constants/countryEnumerations');

            self.registerViewModel = (viewModel, facade) => {

                _viewModel = viewModel;
                _facade = facade;
                _commonValidator = new CommonValidatorConstructor(_viewModel);

                const validationRules = new ValidationRulesConstructor();
                validationRules.array("messageRecipients")
                    .arrayField("emailAddress")
                    .addValidationKeyUp(_validateEmailAddress)
                    .addValidationI18n(_validateEmailAddress, 'onboardingDelivery:emailAddressInvalid')
                    .addValidationI18n(_isEmailAddressUnique, 'onboardingDelivery:emailAddressDuplicate');
                validationRules.array("smsRecipients")
                    .arrayField("number")
                    .addValidationKeyUp(_validatePhoneNumber)
                    .addValidationI18n(_isSmsNumberProvided, 'onboardingDelivery:phoneNumberRequired')
                    .addValidationI18n(_validatePhoneNumber, 'onboardingDelivery:phoneNumberInvalid')
                    .addValidationI18n(_isPhoneNumberUnique, 'onboardingDelivery:phoneNumberDuplicate');

                _commonValidator.setValidationRules(validationRules);
            };

            self.validate = () => {
                return _commonValidator.validate();
            };

            self.validateMinimumRequiredFields = () => {
                return _promiseFactory.defer((deferredObject) => {
                    const hasAtLeastOneRequiredField = !_areRequiredInputsEmpty();
                    deferredObject.resolve(hasAtLeastOneRequiredField);
                });
            };

            const _isArrayOfInputsEmpty = (inputs) => {
                return !inputs.some((input) => _commonValidator.isStringWithValue(input));
            };

            const _areRequiredInputsEmpty = () => {
                const emailAddresses = _viewModel.messageRecipients().map((recipient) => recipient.emailAddress());
                return _isArrayOfInputsEmpty(emailAddresses);
            };

            const _validateEmailAddress = (emailAddress) => {
                if (_commonValidator.isStringWithValue(emailAddress)) {
                    return _validEmailAddressSpecification.isSatisfiedBy(emailAddress.trim());
                } else {
                    return true;
                }
            };

            const _isEmailAddressUnique = (emailAddress) => {
                if (_commonValidator.isStringWithValue(emailAddress) === false) {
                    return true;
                }
                const messageRecipients = _viewModel.messageRecipients();
                const matchingEmailAddresses = messageRecipients.filter((e) => {
                    return e.emailAddress().trim().toLowerCase() === emailAddress.trim().toLowerCase();
                });
                return matchingEmailAddresses.length === 1;
            };

            const _isSmsNumberProvided = (phoneNumber) => {
                if (_viewModel.shouldDisplaySmsNotifications() !== true) {
                    return true;
                }
                if (_commonValidator.isStringWithValue(phoneNumber)) {
                    return true;
                }
                return _viewModel.smsRecipients()
                    .some((recipient) => _commonValidator.isStringWithValue(recipient.number()));
            };

            const _validatePhoneNumber = (phoneNumber) => {
                if (_commonValidator.isStringWithValue(phoneNumber)) {
                    let cleanPhoneNumber = _phoneNumberFormatter.clean(phoneNumber);
                    return _validPhoneNumberSpecification.isSatisfiedBy(cleanPhoneNumber, _countryEnumerations.usa);
                } else {
                    return true;
                }
            };

            const _isPhoneNumberUnique = (phoneNumber) => {
                if (_commonValidator.isStringWithValue(phoneNumber) === false) {
                    return true;
                }
                const smsRecipients = _viewModel.smsRecipients();
                const matchingPhoneNumbers = smsRecipients.filter((s) => {
                    return _phoneNumberFormatter.clean(s.number().trim()) ===  _phoneNumberFormatter.clean(phoneNumber.trim());
                });
                return matchingPhoneNumbers.length === 1;
            };

        };
    });
